import apiClient from './client'

export const lecturesApi = {
  getLecture: async (id) => {
    const response = await apiClient.get(`/lectures/${id}`)
    return response.data
  },

  getChapterLectures: async (id) => {
    const response = await apiClient.get(`/chapters/${id}/lectures`)
    return response.data
  },

  saveNote: async (lectureId, data) => {
    const response = await apiClient.post(`/lectures/${lectureId}/notes`, data)
    return response.data
  },

  getNotes: async (params = {}) => {
    const response = await apiClient.get('/notes', { params })
    return response.data
  },

  updateNote: async (id, data) => {
    const response = await apiClient.put(`/notes/${id}`, data)
    return response.data
  },

  deleteNote: async (id) => {
    const response = await apiClient.delete(`/notes/${id}`)
    return response.data
  },
}

